import { API_BASE_URL } from "@/api/api.config";
import useRestQuery, { UseRestQueryResponse } from "@/remoteState/useRestQuery";
import { AttachmentWrapper } from "@/types/models/ContentAttachment.interface";

const useContentAttachmentsGet = (
  contentId: string,
): UseRestQueryResponse<AttachmentWrapper> => {
  const requestUrl = `${API_BASE_URL}/api/v3/content-document/${contentId}/attachments/`;
  return useRestQuery(requestUrl);
};

export default useContentAttachmentsGet;
